"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
export default function About() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const {
    ref: blockquoteRef,
    isVisible: blockquoteVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section id="about" className="dark bg-background text-foreground py-24 px-4 md:px-8 lg:px-20">
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {}
          <div ref={leftRef} className={`space-y-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <div className="space-y-4">
              <h2 className="text-4xl font-extrabold leading-tight !text-[hsl(35,88%,47%)] ![margin:0px_0px_16px_0px] md:text-5xl">Tentang Fakta Integritas</h2>
              <p className="text-lg text-muted-foreground leading-relaxed">Kantor Hukum Fakta Integritas lahir dari kesadaran bahwa hukum tidak hanya menjadi perangkat normatif, tetapi juga instrumen moral dan sosial untuk menegakkan kebenaran serta menjaga keadilan substantif.</p>
            </div>

            {}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <Card data-index={0} className="bg-secondary/60 border border-muted hover:border-primary/50 hover:shadow-[inset_0_0_20px_rgba(253,191,0,0.15)] transition-all duration-300 p-6">
                <CardContent className="space-y-3 p-0">
                  <h3 className="text-xl font-bold !text-[hsl(35,93%,58%)]">Fakta</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">Representasi kebenaran objektif yang menjadi dasar setiap argumentasi hukum</p>
                </CardContent>
              </Card>

              <Card data-index={1} className="bg-secondary/60 border border-muted hover:border-primary/50 hover:shadow-[inset_0_0_20px_rgba(253,191,0,0.15)] transition-all duration-300 p-6">
                <CardContent className="space-y-3 p-0">
                  <h3 className="text-xl font-bold !text-[hsl(35,93%,58%)]">Integritas</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">Prinsip moral yang mengikat setiap advokat dalam menjalankan profesinya secara jujur dan bertanggung jawab</p>
                </CardContent>
              </Card>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`space-y-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            

            <p className="text-base text-muted-foreground leading-relaxed">Kantor Hukum Fakta Integritas berpegang teguh pada keyakinan bahwa hukum tanpa integritas hanyalah teks tanpa jiwa. Integritas menjadi fondasi utama yang membedakan antara praktik hukum yang beretika dan praktik hukum yang oportunistik.</p>

            {}
            <div ref={blockquoteRef} className={`border-l-4 border-primary pl-6 py-4 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${blockquoteVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`} style={{
            transitionDelay: blockquoteVisible ? "200ms" : "0ms"
          }}>
              <p className="text-lg italic text-foreground/90 leading-relaxed">"Nama Fakta Integritas bukan sekadar identitas lembaga, tetapi juga janji moral kepada klien dan masyarakat bahwa setiap tindakan hukum yang dilakukan akan berakar pada kebenaran faktual dan dijalankan dengan kejujuran serta tanggung jawab".</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}